import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bb6631c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nps-stats-container" }
const _hoisted_2 = { class: "total uk-width-4-10" }
const _hoisted_3 = { class: "stat" }
const _hoisted_4 = { class: "number" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "TOTAL RESPONSES", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "sm-label" }
const _hoisted_8 = { class: "positive uk-width-3-10" }
const _hoisted_9 = { class: "stat" }
const _hoisted_10 = { class: "number" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "POSITIVE", -1))
const _hoisted_12 = { class: "others uk-width-3-10" }
const _hoisted_13 = { class: "stat" }
const _hoisted_14 = { class: "number" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "THINGS TO WORK ON", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoTooltip = _resolveComponent("InfoTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.tsNpsSummary.total), 1),
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, [
          _createTextVNode(" incl. dropouts  "),
          _createVNode(_component_InfoTooltip, null, {
            default: _withCtx(() => [
              _createTextVNode("Some survey respondents answered but did not select feedback for the personal scorecard.")
            ], undefined, true),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.tsNpsSummary.promoter), 1),
        _hoisted_11
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("span", _hoisted_13, [
        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.thingsToWorkOnCount), 1),
        _hoisted_15
      ])
    ])
  ]))
}